/* NTT collection intro fold (10/06/26).
   Phones only. The intro text always stays in the page for Google and for
   screen readers. This script only adds the "Read more" button that the CSS in
   assets/ntt-nav-breadcrumb.css (section 6) leaves room for. If this file is
   removed, also remove section 6 of that stylesheet. */
(function () {
  function init() {
    if (!document.body || !document.body.classList.contains('template-collection')) return;
    var box = document.querySelector('[id^="ntt-"][id$="-hero-copy"] .ntt-copy, .ntt-toprated-hero');
    if (!box || box.querySelector('.ntt-intro-toggle')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ntt-intro-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Read more';
    btn.addEventListener('click', function () {
      var open = box.classList.toggle('ntt-intro-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Show less' : 'Read more';
    });
    box.appendChild(btn);
    box.classList.add('ntt-intro-ready');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
